<template>
    <div class="form-type-0">
        <form @submit.prevent="confirmCheckout" @input="onInputChange" ref="form" novalidate>
            <CustomRadio
                v-model="method"
                inputKey="checkout_methods"
                :options="methodOptions"
                ref="method"
                cssClass="custom-radio-type-5"
                :showLabel="false"
            />

            <button type="submit" :disabled="loading">
                <span v-if="loading" class="loading-spinner-type-1 primary"></span>
                <span v-else>{{$t(method === 'consult' ? 'forms.checkout_method.button_consult' : 'forms.checkout_method.button_checkout') }}</span>
            </button>
        </form>
    </div>
</template>

<script>
    import router from '@/router';
    import formMixin from '@/mixins/formMixin';
    import { useDatasetStore } from '@/stores/dataset';
    import CustomRadio from '@/components/elements/inputs/CustomRadio';

    export default {
        mixins: [formMixin],
        emits: ['form_submission_successful'],
        components: {
            CustomRadio
        },
        data() {
            return {
                method: 'checkout',
                methodOptions: [
                    {
                        value: 'checkout',
                        text: 'fields.checkout_methods.checkout.label',
                        description: 'fields.checkout_methods.checkout.description',
                        image: ["ideal", "amex", "mastercard", "visa"]
                    },
                    {
                        value: 'consult',
                        text: 'fields.checkout_methods.consult.label',
                        description: 'fields.checkout_methods.consult.description',
                        image: "headset"
                    },
                ],
            };
        },
        computed: {
            datasetStore() {
                return useDatasetStore();
            }
        },
        methods: {
            confirmCheckout() {
                const route = this.method === 'consult' ? 'consult' : 'order-checkout';
                router.push({ name: route });
            }
        },
        mounted() {
            this.datasetStore.refs.methodForm = this;
        },
        unmounted() {
            this.datasetStore.refs.methodForm = null;
        },
    }
</script>